import React, { useEffect, useState } from "react";
import EdModal from "@frameworks/web/components/generic/edModal";
import "@frameworks/web/stylesheets/components/Reports/SubscriptionFees/SubscriptionPopup.scss";
import { addDashIfNullOrUndefined } from "@domains/utils/numberMethods";
import GenericTable from "@frameworks/web/components/generic/GenericTable";
import DeviceContext from "@frameworks/web/utils/indentifyDevice";
import GenericDrawer from "@frameworks/web/components/generic/TOCgeneric/GenericDrawer";
import subscriptionDi from "./di/servicelocator";
import DownloadAndEmail from "./DownloadAndEmail";
import Common_Shimmer from "@frameworks/web/components/features/Markets/Equity/Equityshimmer/common_shimmer";
const SubscriptionPopup = (props) => {
    const device = DeviceContext();
    const [tableData, setTableData] = useState([]);
    const [toastShow, setToastShow] = useState(true);
    const [loader, setLoader] = useState(false);
    const subscriptionPopupColumn = [
        {
            columnName: "Date",
            arrows: false,
            key: "date",
            columnClassName: "text-nowrap",
            tdCustomFunction: addDashIfNullOrUndefined,
        },
        {
            columnName: "Brok Delivery (₹)",
            arrows: false,
            key: "brokDelivery",
            columnClassName: "text-nowrap text-end",
            tdCustomFunction: addDashIfNullOrUndefined,
        },
        {
            columnName: "Brok Intraday (₹)",
            arrows: false,
            key: "brokIntraday",
            columnClassName: "text-nowrap text-end",
            tdCustomFunction: addDashIfNullOrUndefined,
        },
        {
            columnName: "Brok Futures (₹)",
            arrows: false,
            key: "brokFutures",
            columnClassName: "text-nowrap text-end",
            tdCustomFunction: addDashIfNullOrUndefined,
        },
        {
            columnName: "Brok Options (₹)",
            arrows: false,
            key: "brokOptions",
            columnClassName: "text-nowrap text-end",
            tdCustomFunction: addDashIfNullOrUndefined,
        },
        {
            columnName: "Brok Currency Futures (₹)",
            arrows: false,
            key: "brokCurrencyFutures",
            columnClassName: "text-nowrap text-end",
            tdCustomFunction: addDashIfNullOrUndefined,
        },
        {
            columnName: "Brok Currency Options (₹)",
            arrows: false,
            key: "brokCurrencyOptions",
            columnClassName: "text-nowrap text-end",
            tdCustomFunction: addDashIfNullOrUndefined,
        },
        {
            columnName: "Brok Total (₹)",
            arrows: false,
            key: "brokTotal",
            columnClassName: "text-nowrap text-end",
            tdCustomFunction: addDashIfNullOrUndefined,
        },
        {
            columnName: "Brok Consumed (₹)",
            arrows: false,
            key: "brokBalance",
            columnClassName: "text-nowrap text-end",
            tdCustomFunction: addDashIfNullOrUndefined,
        },
    ];
    useEffect(() => {
        var _a;
        if (props === null || props === void 0 ? void 0 : props.schemeRefNo) {
            setLoader(true);
            let payload = {
                schemeRefNo: props.schemeRefNo,
            };
            (_a = subscriptionDi === null || subscriptionDi === void 0 ? void 0 : subscriptionDi.subscriptionReport) === null || _a === void 0 ? void 0 : _a.getSubscriptionPopup(payload).then((data) => {
                setTableData(data.rateBased);
            }).finally(() => {
                setLoader(false);
            });
        }
    }, [props === null || props === void 0 ? void 0 : props.schemeRefNo]);
    return (React.createElement("div", null, (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(EdModal, { show: props.subscriptionPopupShow, setShow: (open) => props.setSubscriptionPopupShow(open), showFooter: false, modalTitle: "subscriptionPopup", title: props === null || props === void 0 ? void 0 : props.schemeName, size: "modal-xl modal-dialog-centered justify-content-center" },
        React.createElement(DownloadAndEmail, { schemeRefNo: props === null || props === void 0 ? void 0 : props.schemeRefNo }),
        React.createElement(GenericTable, { columns: subscriptionPopupColumn, data: tableData, parentClassName: "subscription-table", loader: loader }))) : (React.createElement("div", null,
        React.createElement(GenericDrawer, { show: props.subscriptionPopupShow, setShow: (show) => props.setSubscriptionPopupShow(show), parentClass: "subscriptionDrawer z-index-high new-background-blur bg_aqua_white commonnew-download-report-drawer", headerComp: React.createElement(React.Fragment, null,
                React.createElement("span", { className: "DMSanN_16_400 txt-midnight-blue px-3" }, props === null || props === void 0 ? void 0 : props.schemeName)), bodyComp: React.createElement(React.Fragment, null, loader ? (React.createElement("div", null,
                React.createElement(Common_Shimmer, null))) : (React.createElement("div", null,
                React.createElement("div", { className: "body-container Subscription-div-scroll" },
                    React.createElement("div", { className: "download-email-wrapper" },
                        React.createElement(DownloadAndEmail, { schemeRefNo: props === null || props === void 0 ? void 0 : props.schemeRefNo })),
                    React.createElement("div", { className: "body-table" }, tableData.map((row) => (React.createElement("div", { className: "subscription-detail-row-container" },
                        React.createElement("div", { className: "txt_black_one1 RobotoM_14_500" }, row.date),
                        React.createElement("div", { className: "subscription-detail-row" },
                            React.createElement("div", { className: "d-flex justify-content-between" },
                                React.createElement("div", { className: "txt_secondary-gray DMSansMedium_12_500" }, "Brok Consumed"),
                                React.createElement("div", { className: "txt_black_one1 RobotoM_14_500" }, row.brokBalance)),
                            React.createElement("div", { className: "d-flex justify-content-between" },
                                React.createElement("div", { className: "txt_secondary-gray DMSansMedium_12_500" }, "Brok Total"),
                                React.createElement("div", { className: "txt_black_one1 RobotoM_14_500" }, row.brokTotal)),
                            React.createElement("div", { className: "d-flex justify-content-between" },
                                React.createElement("div", { className: "txt_secondary-gray DMSansMedium_12_500" }, "Brok Delivery"),
                                React.createElement("div", { className: "txt_black_one1 RobotoM_14_500" }, row.brokDelivery))))))))))) })))));
};
export default SubscriptionPopup;
